import { Component, Input, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { StoreService } from 'app/services';
import { PartnerMartLocationsMenuLevel3Enum } from '../../partner-mart-locations-root/partner-mart-locations-root.component';
import { LegalDocumentStatusEnum } from 'app/models';
import moment from 'moment';

@Component({
    selector: 'partner-mart-locations-legal-documents',
    templateUrl: './partner-mart-locations-legal-documents.component.html',
    styleUrls: ['./partner-mart-locations-legal-documents.component.scss'],
    providers: [MessageService]
})
export class PartnerMartLocationsLegalDocumentsComponent implements OnInit {
    @Input()
    public storeId: number = 0;
    @Input()
    public store: any = {};
    @Input()
    public activeDocumentMenuItem: PartnerMartLocationsMenuLevel3Enum = PartnerMartLocationsMenuLevel3Enum.None;

    public menuLevel3Enum = PartnerMartLocationsMenuLevel3Enum;

    public legalDocumentStatusEnum = LegalDocumentStatusEnum;
    public showStatusPopup: boolean = false;

    public loading: boolean = false;
    public BIR2303: any = {
        DocumentIssueDate: null,
        DocumentExpirationDate: null,
        DocumentNumber: null
    };
    public businessPermit: any = {
        DocumentIssueDate: null,
        DocumentExpirationDate: null,
        DocumentNumber: null
    };

    public BIR2303OnReview: any = {};
    public businessPermitOnReview: any = {};

    public showLegalDocumentUpdateSidebar: boolean = false;

    constructor(private messageService: MessageService, private storeService: StoreService) {
        this.handleUpdateLegalDocsHide = this.handleUpdateLegalDocsHide.bind(this);
    }

    ngOnInit(): void {
        this.loadDocuments();
    }

    loadDocuments() {
        const dto = {
            StoreId: this.store.Id
        };

        this.storeService.getStoreLegalDocuments(dto, this.messageService)
            .then(data => {
                if (!data) {
                    this.loading = false;
                    return;
                }

                if (!data.Success) {
                    this.loading = false;
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }

                if (data.BIR2303) {
                    this.BIR2303 = data.BIR2303;
                    this.BIR2303.DocumentIssueDate = new Date(this.BIR2303.DocumentIssueDate);
                    this.BIR2303.DocumentExpirationDate = new Date(this.BIR2303.DocumentExpirationDate);
                }

                if (data.BusinessPermit) {
                    this.businessPermit = data.BusinessPermit;
                    this.businessPermit.DocumentIssueDate = new Date(this.businessPermit.DocumentIssueDate);
                    this.businessPermit.DocumentExpirationDate = new Date(this.businessPermit.DocumentExpirationDate);
                }

                if (data.BIR2303OnReview) {
                    this.BIR2303OnReview = data.BIR2303OnReview;
                    this.BIR2303OnReview.IssueDateStr = moment(new Date(this.BIR2303OnReview.DocumentIssueDate)).format('MM/DD/YYYY');
                    this.BIR2303OnReview.ExpiredDateStr = moment(new Date(this.BIR2303OnReview.DocumentExpirationDate).toDateString()).format('MM/DD/YYYY');
                }

                if (data.BusinessPermitOnReview) {
                    this.businessPermitOnReview = data.BusinessPermitOnReview;
                    this.businessPermitOnReview.IssueDateStr = moment(new Date(this.businessPermitOnReview.DocumentIssueDate)).format('MM/DD/YYYY');
                    this.businessPermitOnReview.ExpiredDateStr = moment(new Date(this.businessPermitOnReview.DocumentExpirationDate).toDateString()).format('MM/DD/YYYY');
                }

                this.loading = false;
            })
            .catch(error => {
                this.loading = false;
                this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
            });
    }

    public handleUpdateLegalDocsHide() {
        this.showLegalDocumentUpdateSidebar = false;
        this.loadDocuments();
    }

}
